import "../assets/css/style.scss";

// theme modules
import Menu from "./modules/Menu";
import "./modules/misc";

// new objects
const menu = new Menu();